import { Component, inject } from '@angular/core';
import {
  AccountService,
  CreateTikTokAccountTikApiIn,
  CreateYoutubeAccountIn
} from '../../services/account/account.service';
import { StorageService } from '../../services/storage/storage.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertAlreadyConnectedComponent } from '../connect/atoms/alert-already-connected/alert-already-connected.component';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-enter-youtube',
  standalone: true,
  imports: [AlertAlreadyConnectedComponent, FormsModule],
  templateUrl: './enter-youtube.component.html',
  styleUrl: './enter-youtube.component.scss'
})
export class EnterYoutubeComponent {

  location: Location = inject(Location);
  accountService: AccountService = inject(AccountService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);

  alreadyConnectedError:
    | {
    title: string;
    icon: string;
    action: string;
  }
    | undefined;

  youtubeHandle: string | undefined;
  errorMessage: string | undefined;

  fetchingAccount = false;

  connectYoutube() {
    if (!this.youtubeHandle) {
      this.errorMessage = 'Please enter a YouTube channel URL or handle';
    } else {
      console.log('youtubeHandle: ', this.youtubeHandle);
      void this.sendYoutubeHandle();
    }
  }

  async sendYoutubeHandle() {
    this.fetchingAccount = true;

    const externalId = this.storageService.get('externalId');
    const businessId = this.storageService.get('businessId');

    const body: CreateYoutubeAccountIn = {
      externalId: externalId!,
      businessId: businessId!,
      channelIdOrHandle: this.youtubeHandle!
    };

    try {
      const createYoutubeAccount_response = await firstValueFrom(
        this.accountService.createYoutubeAccount(body)
      );
      console.log('Create YouTube account response: ', createYoutubeAccount_response);
      this.accountService.enterYoutube = createYoutubeAccount_response;
      this.fetchingAccount = false;
      this.router.navigate(['/enter-youtube-complete']);
    } catch (createYoutubeAccount_error) {
      console.error('Error creating YouTube account: ', createYoutubeAccount_error);
      this.fetchingAccount = false;
      this.errorMessage = 'Error creating YouTube account';
    }
  }

  goBack() {
    this.location.back();
  }
}
